import React, { FC, useState } from 'react';
import { BaseModal, FileUploader, Input, Multiselect } from '@cokitchen/cokitchen-components';
import { ReactComponent as WalletIcon } from 'assets/icons/empty-wallet-add.svg';
import { RecordPaymentFooter } from './record-payment-footer';
import { PartnerType } from 'models/partner.model';
import { apiService } from 'utils/api';
import { STORAGE_KEYS } from 'utils/constants';

type RecordPaymentProps = {
  onClose: () => void;
  onComplete?: () => void;
  partner: PartnerType;
};

const RecordPayment: FC<RecordPaymentProps> = ({ onClose, partner }) => {
  const emptyForm = {
    amount: '',
    note: ''
  };
  const [loading, setLoading] = useState(false);
  const [fileUrl, setFileUrl] = useState('');
  const [formData, setFormData] = useState(emptyForm);
  const [datePaid, setDatePaid] = useState<string[]>([]);

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleFileSubmitted = () => {
    setLoading(true);
    apiService.post('logistics/delivery-partner/pay', {
      baseUrl: process.env.REACT_APP_ORDER_STATS_API_KEY,
      data: {
        ...formData,
        logistics_company_id: partner.id
      }
    });
    setLoading(false);
  };

  const datePaidOptions = [
    {
      text: '3/13/2022',
      value: '10'
    },
    {
      text: '11/8/2022',
      value: '7'
    },
    {
      text: '7/8/2022',
      value: '2'
    },
    {
      text: '3/4/2022',
      value: '2'
    },
    {
      text: '3/16/2022',
      value: '8'
    }
  ];
  return (
    <BaseModal
      isOpen
      title='Record Payment'
      description={`Add record for amount paid out to ${partner.name}?`}
      titleIcon={<WalletIcon />}
      titleIconColor='info'
      onRequestClose={onClose}
      footer={
        <RecordPaymentFooter
          loading={loading}
          onCancel={onClose}
          onConfirm={handleFileSubmitted}
          disabled={!formData?.amount || datePaid.length === 0 || !fileUrl}
        />
      }>
      <div className='mt-3 space-y-3 overflow-scroll no-scroll-bar h-[320px]'>
        <Input
          currency
          name='amount'
          label='Enter Amount'
          placeholder='amout'
          small
          onChange={handleChange}
          value={formData?.amount}
        />
        <div className='z-50'>
          <label className='font-medium'>Date Paid</label>
          <Multiselect
            placeholder='Select date'
            isSingle
            values={datePaid}
            options={datePaidOptions}
            onChange={setDatePaid}
          />
        </div>
        <Input
          name='note'
          label='Add note'
          placeholder='Delivery fee added to wallet'
          small
          onChange={handleChange}
          value={formData?.note}
        />
        <div>
          <label className='font-medium'>Add receipt</label>
          <FileUploader
            token={localStorage.getItem(STORAGE_KEYS.TOKEN) as string}
            fileUrls={fileUrl ? [fileUrl] : []}
            setFileUrls={(files) => setFileUrl(files.length ? files[0] : '')}
            fileType='document'
            className='mt-2'
          />
        </div>
      </div>
    </BaseModal>
  );
};

export default RecordPayment;
